import { render, staticRenderFns } from "./OrderTemplateSnackbar.vue?vue&type=template&id=0553885a&"
import script from "./OrderTemplateSnackbar.vue?vue&type=script&lang=js&"
export * from "./OrderTemplateSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports